Auth = require 'app/scripts/db/auth'
Dates = require 'app/scripts/lib/dates'
Label = require 'app/scripts/models/label'
LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
moment = require 'moment'
l = require 'app/scripts/lib/localize'
{ satisfiesFilter, getWords, ID_NONE } = require 'app/common/lib/util/satisfies-filter'

module.exports = class CardFilter extends LocalStorageModel
  constructor: (@board, options) ->
    super(null, options)
    @waitForId @board, (idBoard) =>
      idMe = Auth.myId()
      @set({ id: "boardCardFilterSettings-#{ idBoard }-#{ idMe }" })
      @fetch()
      @_resetNewCards()

    @dueMap =
      day: 1
      week: 7
      month: 28
      overdue: 0
      notdue: 0
      complete: 0
      incomplete: 0

    @modeMap =
      or: 'or'
      and: 'and'

    @newCardsWithoutIds = []

    @listenTo @, 'change:title change:idLabels change:idMembers change:due',
      @debounce @_resetNewCards

  default: ->
    { idMembers: [], idLabels: [], title: null, due: null, limitMembers: true, limitLabels: true, newCards: [], mode: 'or' }

  clear: ->
    @save(@default())

  getBoard: ->
    @board

  _resetNewCards: ->
    @newCardsWithoutIds = []
    @save('newCards', [])

  toggleQuietMode: ->
    idMe = Auth.myId()
    return if !idMe?

    # Quiet Mode is the defaults, except that idMembers is set to you only
    quietState = @default()
    quietState.idMembers = [idMe]

    isInQuietMode = true
    for key, value of quietState
      # We don't have to worry about array ordering; all the arrays we're checking are
      # empty or contain one element
      isInQuietMode &&= _.isEqual(@get(key), value)

    if isInQuietMode
      @clear()
    else
      @save(quietState)

  toggleIdLabel: (idLabel) ->
    @toggle('idLabels', idLabel)

  toggleMember: (idMember) ->
    @toggle('idMembers', idMember)

  isFiltering: ->
    _.some([!_.isEmpty(@get('idMembers')), !_.isEmpty(@get('idLabels')), @get('title')?.trim(), @get('due')?])

  checkItemSatisfiesFilter: (checkItem) ->
    card = checkItem.getCard()

    return satisfiesFilter({
      idMembers: [checkItem.get('idMember')]
      idLabels: card.get('idLabels')
      due: if checkItem.get('due') then new Date(checkItem.get('due')) else null
      complete: checkItem.get('state') == 'complete'
      words: getWords(checkItem.get('name'))
    }, @toJSON())

  satisfiesFilter: (card) ->
    if !card?
      return false

    # cards in the archive are using CardView, so they could be filtered.
    # We want to always show them.
    if card.get('closed')
      return true

    if card.id in (@get('newCards') ? []) || card in @newCardsWithoutIds
      return true

    return satisfiesFilter({
      idMembers: card.get('idMembers')
      idLabels: card.get('idLabels')
      due: if card.get('due') then new Date(card.get('due')) else null
      complete: card.get('dueComplete')
      words: _.chain([
        getWords(card.get('name')),
        getWords(card.get('idShort')?.toString())
        if card.getBoard().isCustomFieldsEnabled()
          card.customFieldItemList.map((cfi) -> cfi.getFilterableWords(getWords))
      ]).compact().flatten().value()
    }, @toJSON())

  addNewCard: (card) ->
    @newCardsWithoutIds.push(card)

    @waitForId card, (idCard) =>
      @newCardsWithoutIds = _.without(@newCardsWithoutIds, card)
      @addToSet('newCards', idCard)

  toJSON: ({ board, expanded } = {}) ->
    json = super
    if board
      json.board = @board.toJSON()

    if expanded
      search = @get('title') ? ''
      # for members, filter on @username and username
      memberRe = ///^#{Util.escapeForRegex(search.replace(/^@/, ''))}///i
      labelRe = ///^#{Util.escapeForRegex(search)}///i

      json.labels = _.chain(@board.getLabels())
        .filter (label) ->
          labelRe.test(label.get('color')) || labelRe.test(label.get('name'))
        .sort(Label.compare)
        .map (label) =>
          _.extend label.toJSON(),
            isActive: label.id in @get('idLabels')
        .unshift
          id: ID_NONE
          name: l(['filtering', 'no labels'])
          isActive: ID_NONE in @get('idLabels')
        .value()

      json.members = @board.memberList.chain()
        .filter (member) ->
          (search == 'me' && Auth.isMe(member)) ||
          _.any(Util.getMemNameArray(member), (name) -> memberRe.test(name))
        .map (member) =>
          _.extend member.toJSON(),
            isActive: member.id in @get('idMembers')
        .value()

      json.members = Util.sortMembers(json.members, Auth.me())
      json.members.unshift
        id: ID_NONE
        fullName: l(['filtering', 'no members'])
        initials: '?'
        isActive: ID_NONE in @get('idMembers')

      json.dueOptions = _.keys(@dueMap).map (time) =>
        time: time
        desc: l(['due date filter', time])
        isActive: time == @get('due')

      json.modes = _.keys(@modeMap).map (mode) =>
        mode: mode
        desc: l(['filter mode', mode])
        isActive: mode == @get('mode')

    json

  toQueryString: ->
    if @isFiltering()
      filters = []

      formatTitle = (title) ->
        title?.replace(/\%/g, '%25')

      if (title = formatTitle(@get('title')))
        filters.push(title)

      @get('idLabels').forEach (idLabel) =>
        if idLabel == ID_NONE
          filters.push("label:none")
        else
          label = @board.modelCache.get('Label', idLabel)
          if label
            if (name = label.get('name'))
              filters.push("label:#{encodeURIComponent(name)}")
            else
              filters.push("label:#{label.get('color')}")

      @get('idMembers').forEach (idMember) =>
        if idMember == ID_NONE
          filters.push("member:none")
        else
          member = @board.modelCache.get('Member', idMember)
          if member
            filters.push("member:#{member.get('username')}")

      if (due = @get('due'))
        filters.push("due:#{due}")

      if @get('mode') == 'and'
        filters.push("mode:and")

      queryObj =
        menu: 'filter'
        filter: filters.join(',')

      '?' + _.chain(queryObj)
      .pairs()
      .map ([key, value]) ->
        [key, value].join('=')
      .join('&')
      .value()
    else
      ""

  fromQueryString: (filter) ->
    if !filter
      return

    idMembers = []
    idLabels = []
    due = undefined
    title = undefined

    for entry in filter.split(',')
      [type, value] = entry.split(':')

      switch type
        when 'member'
          if value == 'none'
            idMembers.push(ID_NONE)
          else
            member = @board.modelCache.findOne 'Member', (mem) ->
              mem.get('username') == value

            if member?
              idMembers.push(member.id)

        when 'label'
          if value == 'none'
            idLabels.push(ID_NONE)
          else
            label = @board.labelList.find (label) ->
              label.get('name').toLowerCase().indexOf(value.toLowerCase()) == 0 ||
              (label.get('name') == '' && label.get('color') == value)

            if label?
              idLabels.push(label.id)

        when 'due'
          if value in _.keys(@dueMap)
            due = value

        when 'mode'
          if value == 'and'
            mode = 'and'

        else
          title = entry

      @set({ idMembers, idLabels, due, title, mode })
